import React from 'react';
import './viewclub.scss';
import Constant from "../../util/constant";
import fixtureImg from '../../assets/images/fixturesPNG.png'
import sponserImg from '../../assets/images/sponsersPNG.png'
import contactImg from '../../assets/images/contactPNG.png'
import { Scrollbars } from 'react-custom-scrollbars';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import CustomMenuBar from '../../components/CustomMenuBar/CustomMenuBar';
import ToastComponent from '../../components/ToastComponent/ToastComponent';
import CustomModal from '../../components/Modal/Modal';
import WebService from "../../util/webService";
import MainContext from '../../MainContext';
import Tooltip from "react-simple-tooltip";
import { uploadClubLogo } from "../../util/helper";
import moment from 'moment';


class ViewClub extends React.Component {
  static contextType = MainContext
  constructor(props) {
    super(props);
    
    this.state = {
      toast: {
        show: false,
        type: "Sucess",
        msg: "The club has been edited successfully.",
        errorToast: false
      },
      clubs: [],
      searchText: '',
      NoData: '',
      typingTimeout: 0,
      togglepageVisible: true,
      detail: {},
      totalUsers: 0,
      clubModalVisible: false,
      clubExistsError: "",
      defaultForm: {},
      clubListUpdated: false
    };
  }
  onEditClick = () => {
    const { detail } = this.state;
    this.setState({
      clubModalVisible: true,
      clubExistsError: "",
      defaultForm: {
        sClubName: detail.sClubName,
        sClubLogo: detail.sClubLogo,
        sLogoBgColour: detail.sLogoBgColour || "",
        bundleId: detail.bundleId || "",
        firebaseProjectId: detail.firebaseProjectId || "",
        appstoreUrl: detail.appstoreUrl || "",
        playstoreUrl: detail.playstoreUrl || "",
        iosMinVersion: detail.iosMinVersion || "",
        iosLatestVersion: detail.iosLatestVersion || "",
        androidMinVersion: detail.androidMinVersion || "",
        androidLatestVersion: detail.androidLatestVersion || ""
      }
    });
  }
  onSubmitClick = async (values) => {
    const { updateButtonLoading } = this.context;
    updateButtonLoading(true);
    const formData = new FormData();
    formData.append("iClubId", this.props.location.state.iClubId);
    let logoUrl = values.sClubLogo;
    if (typeof values.sClubLogo !== "string") {
      logoUrl = await uploadClubLogo(values.sClubLogo, this.state.detail.sClubIdentifier);
    }
    formData.append("sClubLogo", logoUrl);
    formData.append("sClubName", values.sClubName);
    formData.append("sLogoBgColour", values.sLogoBgColour || "");
    formData.append("bundleId", values.bundleId || "");
    formData.append("firebaseProjectId", values.firebaseProjectId || "");
    formData.append("appstoreUrl", values.appstoreUrl || "");
    formData.append("playstoreUrl", values.playstoreUrl || "");
    formData.append("iosMinVersion", values.iosMinVersion || "");
    formData.append("iosLatestVersion", values.iosLatestVersion || "");
    formData.append("androidMinVersion", values.androidMinVersion || "");
    formData.append("androidLatestVersion", values.androidLatestVersion || "");
    await WebService.postWebServices(Constant.API.CLUB_EDIT, formData, (response) => {
      if (response.status || response.status >= 200 || response.status <= 210) {
        if (response.data.status === true) {
          this.setState({
            clubModalVisible: false,
            clubExistsError: "",
            defaultForm: {},
            clubListUpdated: !this.state.clubListUpdated,
            toast: {
              show: true,
              type: "Success",
              msg: response.data.msg,
              errorToast: false
            }
          });
          this.getDetail();
        } else {
          this.setState({
            clubExistsError: response.data.msg
          });
        }
      }
    });
    updateButtonLoading(false);
    setTimeout(() => {
      this.setState({
        toast: {
          show: false,
          type: this.state.toast.type,
          msg: this.state.toast.msg,
          errorToast: this.state.toast.errorToast
        }
      });
    }, 5000);
  }
  onApply(toggleVisible) {
    this.setState({ togglepageVisible: toggleVisible })
  }
  getDetail = async () => {
    const id = this.props.location.state.iClubId;
    await WebService.getWebServices(
      Constant.API.CLUB_DETAIL,
      { oClubId: id },
      (response) => {
        if (response.status >= 200 || response.status <= 210) {
          let mainData = response.data.data;
          if (response.data.status === true) {
            this.setState({
              detail: mainData,
              totalUsers: response.data.totalUsers
            });
          } else {
            this.setState({
              detail: {},
              NoData: mainData.msg
            });
          }
        }
      });
  }
  componentWillMount() {
    if(!this.props.location.state){
      this.props.history.push('/clubs')
    }else{
      this.getDetail();
    }
  }
  componentDidUpdate(prevProps) {
    const prevId = prevProps.location.state && prevProps.location.state.iClubId;
    const currentId = this.props.location.state && this.props.location.state.iClubId;
    if (currentId && currentId !== prevId) {
      this.getDetail();
    }
  }
  render() {
    const { toast, totalUsers, detail, clubModalVisible, clubExistsError, defaultForm, clubListUpdated } = this.state;
    // Only flag once the club has actually loaded, otherwise every field reads as
    // missing during the initial fetch.
    const missingAppConfig = detail.sClubIdentifier ? [
      !detail.bundleId && 'Bundle ID',
      !detail.appstoreUrl && 'App Store URL',
      !detail.playstoreUrl && 'Play Store URL'
    ].filter(Boolean) : [];
    return (
      <div className="ViewClubPage">
        <Header {...this.props} logonotVisible={true} />
        <CustomMenuBar onToggleClick={(toggleVisible) => this.onApply(toggleVisible)} {...this.props} clubListUpdated={clubListUpdated} />
        <div className="centerSec">
          <ToastComponent  onClose={() => {
          this.setState({
            toast: {
              show: false,
              type: this.state.toast.type,
              msg: this.state.toast.msg,
              errorToast: this.state.toast.errorToast
            }
          })
        }} show={toast.show} toastMessage={toast.msg} toastMessageTye={toast.type} errorToast={toast.errorToast} />
          <div className={this.context.isDrawerOpen ? "rightMain" : "rightMain sidePadding"} >
            <div className="searchSec">
              <a className="backICON" onClick={() => { this.props.history.push('clubs') }}><i className="icon-left-arrow" />
              <span className="blackdarkTxt" onClick={() => { this.props.history.push('clubs') }}>Clubs</span></a>
              {/* <span className="divider"></span> */}
              {/* <div className="searchMain">
                <SearchBox placeholder="Search..." onChange={this.onSearch} />
              </div> */}
            </div>
            <Scrollbars className="clublisting">
              <div className="pageinnerscroll">
                <div className="listingTopSec">
                  <div className="backImgSec">
                    <div className="imgCircle">
                      <div className="imgDiv">
                        <img src={detail.sClubLogo} className="clublogoMain" alt="" style={detail.sLogoBgColour ? { backgroundColor: detail.sLogoBgColour } : undefined} />
                      </div>
                    </div>
                  </div>
                  <div className="blacTxtSec">
                    <span className="blacTxt">{detail.sClubName}</span>
                    <a className="editClubBtn" onClick={this.onEditClick}>
                      <Tooltip content="EDIT" placement="right" className="tooltipSmall">
                        <i className="icon-edit_pencil"></i>
                      </Tooltip>
                    </a>
                  </div>
                  <div className="greyTxtSec">
                    <span className="greyTxt">{totalUsers} <span className="greyTxt">{parseInt(totalUsers) === 1 ? 'User' : 'Users'}</span></span>
                  </div>
                  <div className="greyTxtSec">
                    <span className="greyTxt">Since {moment(detail.dCreatedAt).format('YYYY')}</span>
                  </div>
                </div>
                {missingAppConfig.length > 0 && (
                  <div className="appConfigWarning" onClick={this.onEditClick}>
                    <span className="appConfigWarningBadge">!</span>
                    <span className="appConfigWarningTxt">
                      Missing {missingAppConfig.join(', ')}.
                      {!detail.bundleId && ' iOS push notifications will not be delivered until a Bundle ID is set.'}
                      <span className="appConfigWarningAction"> Click to edit.</span>
                    </span>
                  </div>
                )}
                <div className="viewClub">
                  <ul>
                    <li>
                      <a className="viewCard" onClick={() => { this.props.history.push('/club/fixtures', { iClubId: this.props.location.state.iClubId, sClubName: detail.sClubName, sClubIdentifier: detail.sClubIdentifier, sClubLogo: detail.sClubLogo, sLogoBgColour: detail.sLogoBgColour, since: moment(detail.dCreatedAt).format('YYYY'), totalUsers: totalUsers }) }} >
                        <div className="imgBig">
                          <img src={fixtureImg} alt="" />
                        </div>
                        <span className="yelloBigTxt">
                          Fixtures & Tables
                          League Associations
                          </span>
                        <div className="background"></div>
                      </a>

                    </li>
                    <li>
                      <a className="viewCard" onClick={() => { this.props.history.push('/club/sponsors', { iClubId: this.props.location.state.iClubId, sClubName: detail.sClubName, sClubIdentifier: detail.sClubIdentifier, sClubLogo: detail.sClubLogo, since: moment(detail.dCreatedAt).format('YYYY'), totalUsers: totalUsers }) }} >
                        <div className="imgBig">
                          <img src={sponserImg} alt="" />
                        </div>
                        <span className="yelloBigTxt">
                          List of Club Sponsors
                          </span>
                        <div className="background"></div>
                      </a>
                    </li>

                    <li>
                      <a className="viewCard" onClick={() => { this.props.history.push('/club/contacts', { iClubId: this.props.location.state.iClubId, sClubName: detail.sClubName, sClubIdentifier: detail.sClubIdentifier, sClubLogo: detail.sClubLogo, since: moment(detail.dCreatedAt).format('YYYY'), totalUsers: totalUsers }) }} >
                        <div className="imgBig">
                          <img src={contactImg} alt="" />
                        </div>
                        <span className="yelloBigTxt">
                          Contact Us Information
                          </span>
                        <div className="background"></div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </Scrollbars>
          </div>
        </div>
        <CustomModal
          _id={this.props.location.state ? this.props.location.state.iClubId : ""}
          showModal={clubModalVisible}
          clubNamePlaceholder="Club Name"
          sClubLogo={defaultForm?.sClubLogo}
          defaultForm={defaultForm}
          onHide={() =>
            this.setState({
              clubModalVisible: false,
              defaultForm: {},
              clubExistsError: ""
            })
          }
          titleName="Edit Club"
          modalType="clubModal"
          clubExistsError={clubExistsError}
          onSubmit={(details) => {
            this.onSubmitClick(details);
          }}
        />
        <Footer divClassname={this.context.isDrawerOpen ? "simpleFooter" : "footersidePadding"} />
      </div >
    )
  }
}

export default (ViewClub);

